import { ProductImageFormat } from './ProductImage';

export function instanceOfProductImageFormat (object: any): object is ProductImageFormat {
  return object.url;
}
